import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/_public/front-channel-logout')({
  staticData: { team: 'users-infra' },
});
